module.exports = __webpack_public_path__ + "img/city.bce1dbc9.png";